import { Controller } from "@hotwired/stimulus"
import ProgressBar from "../helpers/progress_bar"
import RequestHelper from "../helpers/request_helper"

const JQUERY_NAMESPACE = ".popularRedemptions"
const OPEN_CLASS = "is-open"

// The index action reaches its format.json branch only when both headers arrive: Rails discards
// an Accept header carrying */* unless the request also looks like an XHR.
const JSON_HEADERS = {
  "X-Requested-With": "XMLHttpRequest",
  "Accept": "application/json, text/plain, */*"
}

export default class extends Controller {
  static get targets() { return ["dateRange", "picker", "select", "tableWrapper"]; }
  static get values() { return { begin: String, end: String }; }

  connect() {
    // A picked range is written back onto this url and never onto the DOM, reproducing jQuery's
    // .data(key, value) cache: a later collection change still carries the range.
    this.url = this.selectTarget.dataset.url

    $(this.dateRangeTarget).daterangepicker({
      buttonClasses: "btn btn-main btn-md",
      cancelButtonClasses: "btn-ghost",
      opens: "left",
      alwaysShowCalendars: true,
      showCustomRangeLabel: false,
      ranges: {
        "Today": [moment(), moment()],
        "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
        "All Time": [moment(this.beginValue, "MM-DD-YYYY"), moment(this.endValue, "MM-DD-YYYY")]
      }
    }, (start, end) => this.applyRange(start, end))

    $(this.dateRangeTarget).
      on(`show.daterangepicker${JQUERY_NAMESPACE}`, () => this.pickerTarget.classList.add(OPEN_CLASS)).
      on(`hide.daterangepicker${JQUERY_NAMESPACE}`, () => this.pickerTarget.classList.remove(OPEN_CLASS))
  }

  disconnect() {
    const picker = $(this.dateRangeTarget).data("daterangepicker")
    if (picker) { picker.remove(); }

    $(this.dateRangeTarget).off(JQUERY_NAMESPACE)
  }

  applyRange(start, end) {
    const newRange = `${start.format("MMDDYYYY")}-${end.format("MMDDYYYY")}`

    this.url = this.url.replace(this.url.split("=")[2], newRange)
    this.reload()
  }

  reload() {
    ProgressBar.start()

    const url = new URL(this.url, window.location.origin)
    url.searchParams.append("gallery", this.selectTarget.selectedOptions[0].value)

    const options = RequestHelper.defaultRequestOptions()
    options.headers = Object.assign({}, options.headers, JSON_HEADERS)

    fetch(url, options).
      then(response => {
        if (!response.ok) { throw new Error(`Table data lookup failed (${response.status})`); }
        return response.json()
      }).
      then(({ partial }) => {
        // Server-rendered HTML from our own origin: Subdomain::PopularRedemptionsController#index
        // render_to_string's subdomain/popular_redemptions/_table_data, whose only interpolations
        // are `= product.name` / `= product.gift_count` (HAML auto-escapes) and
        // ProductDecorator#image_tag's `alt:` (escaped by Rails' own tag builder). No raw/
        // html_safe/`!=` anywhere in the partial.
        this.tableWrapperTarget.innerHTML = partial
        ProgressBar.stop()
      }).
      catch(response => {
        console.warn("Unable to retrieve table data", response)
        ProgressBar.stop()
      })
  }
}
